import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';


@Injectable({
  providedIn: 'root'
})
export class TranslaterService {
  baseUrl: string = Constants.CORE_API_BASE_URL;
  constructor(
    public translate: TranslateService,
    private http: HttpClient
  ) {
    translate.addLangs(['en', 'ar','fr','sp','gr','du']);
    translate.setDefaultLang('en');
  }

  public switchLang(lang: string) {
    this.translate.use(lang);
  }

  getLangWords(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Language/getLanguageTags', data);
  }

}
